// frontend/src/api/chatAPI.js
import axios from 'axios';
import { API_BASE_URL, authHeader } from './axiosConfig';

const chatAPI = {
  // Get all team users (for the user picker list)
  getTeamUsers: async () => {
    const res = await axios.get(`${API_BASE_URL}/chat/users`, {
      headers: authHeader()
    });
    return res.data;
  },

  // Get messages between current user and another user
  getMessages: async (otherUserId) => {
    const res = await axios.get(`${API_BASE_URL}/chat/messages/${otherUserId}`, {
      headers: authHeader()
    });
    return res.data;
  },

  // Send a message to another user
  sendMessage: async (receiverId, message) => {
    const res = await axios.post(
      `${API_BASE_URL}/chat/messages`,
      { receiver_id: receiverId, message },
      { headers: authHeader() }
    );
    return res.data;
  },

  // Mark messages from a user as read
  markRead: async (senderId) => {
    const res = await axios.put(
      `${API_BASE_URL}/chat/messages/${senderId}/read`,
      {},
      { headers: authHeader() }
    );
    return res.data;
  },

  // Get total unread count (for bubble badge)
  getUnreadCount: async () => {
    const res = await axios.get(`${API_BASE_URL}/chat/unread-count`, {
      headers: authHeader()
    });
    return res.data?.count || 0;
  }
};

export default chatAPI;
